import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "../../actions";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {

    GetDisplayTypesList: () => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Displays/DisplayTypes", { method: "GET" }).then((data) => {
            return dispatch({ type: types.GET_DICTIONNARY_DISPLAYTYPES, assets: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetTimezonesList: () => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCenters/Timezones", { method: "GET" }).then((data) => {
            return dispatch({ type: types.GET_DICTIONNARY_TIMEZONES, assets: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetDisplayLogs: (uniqueId, onSuccess) => async (dispatch, store) => {
        requestAuth(appSettings.SKALINKAPIURL + "/api/Logging/GetLogFiles/" + btoa(uniqueId), { method: "GET" }).then((data) => {
            console.log("logs " + uniqueId, data);
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetDisplaysList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        secondary ? dispatch({ type: types.GET_DISPLAYS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_DISPLAYS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}

        const orgId = store().currentuser.currentorganization.id;

        const apiName = "OrganizationDisplays";

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Displays/" + apiName + "/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , { method: "GET" }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_DISPLAYS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_DISPLAYS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveDisplaysPagination: (paginationType) => (dispatch, store) => {
        const data = store().monitoring.displays;
        dispatch({ type: types.GET_DISPLAYS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetSecondaryDisplaysList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetDisplaysList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetDisplay: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Displays/" + id, { method: "GET" }).then((data) => {
            dispatch({ type: types.GET_DISPLAY_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteDisplay: (Id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Displays/" + Id, { method: "DELETE" }).then((data) => {
            toast.success(strings.displayDeleted);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditDisplay: (changed, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Displays/" + changed.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changed),
            method: "PUT"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });

    },

    CreateDisplay: (newEl, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Displays", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newEl),
            method: "POST"
        }).then((data) => {
            toast.success(strings.displaySaved);
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetAvailableClientsList: (onSuccess) => async (dispatch, store) => {
        if (!store().communication.linkedPortalAgent) {return onSuccess([]);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/PortalAgents/GetAvailableClientsList/" + store().communication.linkedPortalAgent.id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(JSON.parse(data));
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetPortalAgentsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        dispatch({ type: types.GET_PORTALAGENTS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/PortalAgents/OrganizationPortalAgents/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , { method: "GET" }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_PORTALAGENTS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SavePortalAgentsPagination: (paginationType) => (dispatch, store) => {
        const data = store().monitoring.portalagents;
        dispatch({ type: types.GET_PORTALAGENTS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetSecondaryPortalAgentsList: (onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_PORTALAGENTS_SECONDARY_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/PortalAgents/AllOrganizationPortalAgents/" + store().currentuser.currentorganization.id,
            { method: "GET" }).then((data) => {
            dispatch({ type: types.GET_PORTALAGENTS_SECONDARY_COMPLETED, payload: { results: data } });
            return;
        }).catch( (data) => {
            console.log(data);
        });
    },

    handleSleepMode: (portalId, mode, onSuccess) => async() => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/PortalAgents/SleepMode/" + portalId + "/" + mode,
            { method: "PUT", body: mode }).then((data) => {
            console.log("SleepMode successfully ==> portalId: ", portalId, "mode: ", mode);
            onSuccess();
        }).catch( (data) => {
            console.log("Error Exception Update updateModeSleep", data);
        });
    }
};
